<template>
    <input
        ref="input"
        type="tel"
        inputmode="numeric"
        autocomplete="tel"
        :value="display"
        @input="onInput"
        v-bind="$attrs"
    />
</template>

<script>
export default {
    name: "InputTel",
    inheritAttrs: false,
    props: {
        value: {
            type: String,
            default: ""
        }
    },
    computed: {
        display() {
            if (!this.value) return ""

            // on récupère juste les chiffres FR (10 max)
            let digits = this.value.replace(/\D/g, "")

            // si stocké en +33 → on enlève 33
            if (digits.startsWith("33")) {
                digits = "0" + digits.slice(2)
            }

            digits = digits.slice(0, 10)

            return digits.match(/.{1,2}/g)?.join(" ") || ""
        }
    },
    methods: {
        onInput(e) {
            let digits = e.target.value.replace(/\D/g, "").slice(0, 10)

            // format visuel
            const formatted = digits.match(/.{1,2}/g)?.join(" ") || ""
            e.target.value = formatted

            // normalisation pour v-model
            let normalized = ""

            if (digits.startsWith("0")) {
                normalized = "+33" + digits.slice(1)
            } else {
                normalized = "+33" + digits
            }

            this.$emit("input", normalized)
        }
    }
}
</script>